/* Native details keep click/keyboard navigation usable without theme upgrades.
 * Mouse hover is based on the actual pointer, not the presence of a touchscreen.
 */
(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('.dz-guided-nav').forEach((nav) => {
      if (nav.dataset.hoverReady) return;
      nav.dataset.hoverReady = 'true';
      const menus = [...nav.querySelectorAll('[data-dz-hover-menu]')];
      const timers = new Map();
      const cancelClose = (menu) => {
        clearTimeout(timers.get(menu));
        timers.delete(menu);
      };
      const sync = () => {
        menus.forEach((menu) => {
          menu.querySelector('summary').setAttribute('aria-expanded', String(menu.open));
        });
        document.body.classList.toggle('dz-guided-menu-open', !!document.querySelector('[data-dz-hover-menu][open]'));
      };
      const setOpen = (menu, value) => {
        cancelClose(menu);
        if (menu.open === value) return;
        if (value) {
          menus.forEach((other) => {
            if (other !== menu) {
              cancelClose(other);
              other.open = false;
            }
          });
        }
        menu.open = value;
        sync();
      };
      const closeAll = () => {
        let changed = false;
        menus.forEach((menu) => {
          cancelClose(menu);
          if (menu.open) {
            menu.open = false;
            changed = true;
          }
        });
        if (changed) sync();
      };
      menus.forEach((menu) => {
        const summary = menu.querySelector('summary');
        const panel = menu.querySelector('.mega-menu');
        panel.id = `${menu.id}-panel`;
        summary.setAttribute('aria-controls', panel.id);
        menu.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse') setOpen(menu, true);
        });
        menu.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse') return;
          cancelClose(menu);
          timers.set(menu, setTimeout(() => setOpen(menu, false), 180));
        });
        summary.addEventListener('click', (event) => {
          if (event.target.closest('a[href]')) return;
          event.preventDefault();
          setOpen(menu, !menu.open);
        });
        menu.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && menu.open) {
            event.preventDefault();
            setOpen(menu, false);
            summary.focus();
          } else if (event.key === 'ArrowDown' && event.target === summary) {
            event.preventDefault();
            setOpen(menu, true);
            panel.querySelector('a[href]')?.focus();
          }
        });
        menu.addEventListener('focusout', (event) => {
          if (event.relatedTarget && !menu.contains(event.relatedTarget)) setOpen(menu, false);
        });
        menu.addEventListener('toggle', sync);
      });
      document.addEventListener('pointerdown', (event) => {
        if (!nav.contains(event.target)) closeAll();
      });
      window.addEventListener('resize', closeAll);
      sync();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
